import { Button, DocumentFile, InputFileTable } from 'stories/components'
import { setLoanNumber } from 'utils/setLoanNumber'

export const NewDocumentsTable = ({
  files,
  setFiles,
  onSubmit,
  onCancel,
}: {
  files: DocumentFile[]
  setFiles: Function
  onSubmit: Function
  onCancel: Function
}) => {
  const loanNumber = setLoanNumber()

  if (!files.length) return null

  return (
    // The floater panel this renders in is a fixed 90vh box, so a long list of new files used to run
    // off the bottom of the screen and take the Add/Cancel buttons with it. Cap the list, scroll it,
    // and keep the buttons pinned below it.
    <div className="p-2 flex flex-col max-h-[calc(90vh-70px)]">
      <div className="flex-1 min-h-0 overflow-y-auto">
        <InputFileTable
          filePath={`loan/${loanNumber}/document`}
          onChange={(files) => setFiles(files)}
          value={files}
          title="New Files"
          defaultCategory=""
          narrow
        />
      </div>

      <div className="flex justify-center mt-2 shrink-0">
        <Button loading={false} color="blue" className="py-[4px]" size={'[13px]'} onClick={() => onSubmit(files)}>
          Add Documents
        </Button>
        <Button loading={false} color="gray" className="py-[4px]" size={'[13px]'} onClick={() => onCancel()}>
          Cancel
        </Button>
      </div>
    </div>
  )
}
